module.exports = __webpack_public_path__ + "static/media/calendar-gray.8c33d837.svg";